import React, { useEffect, useState } from "react";
import { FaEllipsisH } from "react-icons/fa";
import Gallery from "../../assets/images/gallery.png";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";
import { Link } from "react-router-dom";

export default function Notifications() {
  const { startLoader, stopLoader } = useLoader();
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const getNotifications = () => {
      startLoader();
      axiosInstance
        .get("/api/notifications/user_notifications/")
        .then((resp) => {
          stopLoader();
          if (resp.status === 200 || resp.status === 201) {
            const Data = resp.data;
            setNotifications(Data);
          }
        })
        .catch(() => {
          stopLoader();
        });
    };
    getNotifications();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <section className="messages-sec pc-p-3">
        <div className="container-fluid px-5">
          {/* <a href="javascript:void(0)" className="a-link color-secondary">Notifications(01)</a> */}
          <div className="row">
            <div className="col-lg-3 col-md-3 col-12">
              {/* <div className="messages-note">
                  <div className="messages-note-box active">
                      <div className="message-notify-box">
                          <div className="row">
                              <div className="col-lg-3">
                                  <div className="message-note-ico">
                                      <figure>
                                          <img src={Gallery} alt="Gallery">
                                      </figure>
                                  </div>
                              </div>
                              <div className="col-lg-9">
                                  <div className="message-note-content">
                                      <h5>User_ Name</h5>
                                      <p>Lorem ipsum dolor sit amet, consectetur</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="messages-note-box">
                      <div className="message-notify-box">
                          <div className="row">
                              <div className="col-lg-3">
                                  <div className="message-note-ico">
                                      <figure>
                                          <img src={Gallery} alt="Gallery">
                                      </figure>
                                  </div>
                              </div>
                              <div className="col-lg-9">
                                  <div className="message-note-content">
                                      <h5>User_ Name</h5>
                                      <p>Lorem ipsum dolor sit amet, consectetur</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="messages-note-box">
                      <div className="message-notify-box">
                          <div className="row">
                              <div className="col-lg-3">
                                  <div className="message-note-ico">
                                      <figure>
                                          <img src={Gallery} alt="Gallery">
                                      </figure>
                                  </div>
                              </div>
                              <div className="col-lg-9">
                                  <div className="message-note-content">
                                      <h5>User_ Name</h5>
                                      <p>Lorem ipsum dolor sit amet, consectetur</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="messages-note-box">
                      <div className="message-notify-box">
                          <div className="row">
                              <div className="col-lg-3">
                                  <div className="message-note-ico">
                                      <figure>
                                          <img src={Gallery} alt="Gallery">
                                      </figure>
                                  </div>
                              </div>
                              <div className="col-lg-9">
                                  <div className="message-note-content">
                                      <h5>User_ Name</h5>
                                      <p>Lorem ipsum dolor sit amet, consectetur</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div> */}
            </div>
            <div className="col-lg-12 col-md-9 col-12">
              <div className="primary-box message-main-box">
                <div className="message-container notification-container">
                  {notifications.map((e, i) => (
                    <div className="message-box" key={i}>
                      <div className="row">
                        <div className="col-lg-1 col-md-1 col-12">
                          <div className="message-note-ico px-2">
                            {!e.is_read ? (
                              <figure>
                                <img src={Gallery} alt="Gallery" />
                              </figure>
                            ) : (
                              <img src={Gallery} alt="Gallery" />
                            )}
                          </div>
                        </div>
                        <div className="col-lg-11 col-md-11 col-12">
                          <div className="message-content">
                            <div className="row">
                              <div className="col-md-10">
                                <div className="primary-heading color-dark">
                                  <h6>
                                    {e.sender} <span>{e.timestamp}</span>
                                  </h6>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="message-opt">
                                  <Link to="#">
                                    <FaEllipsisH />
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <p>{e.content}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
